/**
 * Subcategories factory:
 *
 * Handle the logic of subcategories.
 *
 * Subcategories appears in a few places:
 * Fans page - when selecting the "wood" category,
 * Products-Catalog - when selecting a category from the list & when we have a chosen hue.
 *
 * The subcategories are being used as another filter after choosing a product category.
 * ( Reminder: even hues at the fan page are being filtered by products categories )
 *
 *
 */
FiltersMdl.factory( 'SubcategoriesFcty', [ '$http', '$q', 'API_URL', 'SubcategoriesSrv', function ( $http, $q, API_URL, SubcategoriesSrv ){

	/*
	*Array that holds all the selected subcategories.
	* Being used in case we need to know what was the previous selection in case the user
	* has selected one of the previous select boxes.
	* */
	var selectedSubCategories = [];

	var PROPERTIES = {
		category: null,
		loading: false,
		subcategories: []
	};

	function Subcategories( config ) {
		angular.extend(this, PROPERTIES, config);
	}


	Subcategories.prototype = {
		constructor: Subcategories,

		/**
		 * Being executed on selection of one of the options in the subcategories section.
		 * The "scope" properties that being used are the index of the select box and the value of the option.
		 * @param scope
		 */
		selectSubcat : function( scope ) {
			var self = this;

			GA.send('Shades Fan', 'Filter');
			//Removes all items after selection, new options would be generated with every selection.
			this.subcategories = this.subcategories.slice( 0, scope.$index + 1 );
			selectedSubCategories = selectedSubCategories.slice( 0, scope.$index + 1 );

			//Check if the selected option has a value ( not just a title of a select box ):
			if ( scope.option ) {
				this.loading = true;

				//Set selection value as the same index of options.
				selectedSubCategories[scope.$index] =  scope.option;

				//Get the next subcategories:
				SubcategoriesSrv.getSubCategories( scope.option ).then (
					function( subcategories ){
						self.loading = false;
						if ( subcategories )
							self.subcategories.push( subcategories );

					});

				//Get items by category ( products/hues ect.. that method should be implementing by an instance of that factory )
				this.getItems(scope.option);
			} else {
				selectedSubCategories.splice( scope.$index, 1 );
				this.getItems( selectedSubCategories[ selectedSubCategories.length - 1 ] ? selectedSubCategories[ selectedSubCategories.length - 1 ] : this.category.id )
			}


		}
	};



	return Subcategories;

}]);